import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {DraftJobPackageDelta} from "../../../models/draft-job-package-delta.model";
import {DraftJobChangeField} from "../../../types/draft-job-change-field.enum";

require('./planning-draft-job-package-delta.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-job-package-delta',
  templateUrl: './planning-draft-job-package-delta.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftJobPackageDeltaComponent {
  @Input() packages: DraftJobPackageDelta;

  public readonly packagesField = DraftJobChangeField.PACKAGES;
}
